"use client"

import { cn } from "@/lib/utils"

const VENUE_NAMES: Record<string, string> = {
  hyperliquid: "HyperLiquid",
  orderly: "Orderly",
  jupiter: "Jupiter",
  ostium: "Ostium",
  lighter: "Lighter",
}

function venueLogo(venue: string): string {
  return `/venues/${venue}.png`
}

interface VenueBadgesProps {
  venues: string[]
  /** Size of each logo circle. Default "sm" = 14px, "xs" = 11px */
  size?: "xs" | "sm"
  className?: string
}

export function VenueBadges({ venues, size = "sm", className }: VenueBadgesProps) {
  if (venues.length === 0) return null

  const dim = size === "xs" ? "h-[11px] w-[11px]" : "h-[14px] w-[14px]"
  const label = venues.length === 1
    ? VENUE_NAMES[venues[0]] ?? venues[0]
    : `${venues.length} venues`

  return (
    <div className={cn("flex items-center gap-1 shrink-0", className)}>
      <div className="flex items-center">
        {venues.map((venue, i) => (
          <img
            key={venue}
            src={venueLogo(venue)}
            alt={VENUE_NAMES[venue] ?? venue}
            title={VENUE_NAMES[venue] ?? venue}
            className={cn(
              dim,
              "rounded-full object-cover ring-[1.5px] ring-background",
              i > 0 && "-ml-1"
            )}
            onError={(e) => { e.currentTarget.style.display = "none" }}
          />
        ))}
      </div>
      <span className="text-[9px] text-muted-foreground leading-none">{label}</span>
    </div>
  )
}
